import { FWDCURVE_CATALOG_PATH, SPOT_CATALOG_PATH } from '@/config/constants';

/**
 * Path (with query) for the OPPOSITE catalog view, filtered to a single code.
 * Spot → Forward Curves, Forward Curves → Spot. Used by the "View in …" links.
 */
export const buildCrossCatalogPath = (isForwardCurves: boolean, code: string): string => {
  const target = isForwardCurves ? SPOT_CATALOG_PATH : FWDCURVE_CATALOG_PATH;
  return `/catalog/${target}?code=${encodeURIComponent(code)}`;
};
